module.exports = __webpack_public_path__ + "img/evaluationing.e712e8d4.png";